import React, { useEffect, useState } from "react";
import BookingScheduler from "./pages/BookingScheduler";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import AppointmentBooked from "./pages/AppointmentBooked";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { ToastContainer } from 'react-toastify';
import NotFound from "./pages/404";

function App() {
 
  return (
    <React.Fragment>
      <ToastContainer position="top-center" />
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/book-appointment" element={<BookingScheduler/>} />
        <Route path="/confirmed" element={<AppointmentBooked/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/*" element={<NotFound/>} />
      </Routes>
      </BrowserRouter>
      
      
    </React.Fragment>
  );
}

export default App;
